const Colors = {
    Black:"#000000",
    Transparent: "transparent",
    White: "#ffffff",
    Text: "#ffffff",
    AppYellow: "#fab700",
    AppBlue: "#3879f0",
    AppGreen: "#02b563",
    AppPink: "#ff4c89"
}

export default Colors;